(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-quantity-increase], [data-quantity-decrease]').forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.quantityIncrease || button.dataset.quantityDecrease;
        const input = document.querySelector(`[data-cart-quantity="${key}"]`);
        if (!input) return;

        const current = Number(input.value) || 0;
        const delta = button.hasAttribute('data-quantity-increase') ? 1 : -1;
        const next = Math.max(0, current + delta);
        input.value = next;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const navEntry = performance.getEntriesByType?.('navigation')?.[0];
    const isHistoryNavigation = navEntry?.type === 'back_forward';
    const shouldResetCollectionScroll = !isHistoryNavigation && !window.location.hash;

    if (shouldResetCollectionScroll) {
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
      const resetScroll = () => window.scrollTo(0, 0);
      resetScroll();
      requestAnimationFrame(resetScroll);
      window.addEventListener('load', () => window.setTimeout(resetScroll, 60), { once: true });
    }

    document.querySelectorAll('[data-native-sort]').forEach((select) => {
      if (select.dataset.sortReady === 'true') return;
      select.dataset.sortReady = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    document.querySelectorAll('.collection-page').forEach((page, pageIndex) => {
      const filters = page.querySelector('[data-theme-filters]');
      const grid = page.querySelector('.collection-products');
      if (!filters || !grid || filters.dataset.ready === 'true') return;
      filters.dataset.ready = 'true';

      const content = page.querySelector('[data-collection-content]');
      const clearBtn = filters.querySelector('[data-theme-filter-clear]');
      const activeEl = filters.querySelector('[data-theme-filter-active]');
      const countEl = page.querySelector('[data-collection-count]');
      const emptyEl = page.querySelector('[data-theme-filter-empty]');
      const pagination = page.querySelector('[data-collection-pagination]');
      const optionBodies = {
        model: filters.querySelector('[data-theme-filter-options="model"]'),
        color: filters.querySelector('[data-theme-filter-options="color"]'),
        size: filters.querySelector('[data-theme-filter-options="size"]'),
        leg: filters.querySelector('[data-theme-filter-options="leg"]')
      };
      const keys = Object.keys(optionBodies).filter((key) => optionBodies[key]);
      const originalHtml = grid.innerHTML;
      const originalCount = countEl ? countEl.textContent : '';
      const filterUid = `ThemeFilter-${pageIndex}-${Date.now()}`;
      const totalPages = Math.max(parseInt(content?.dataset.collectionPages || '1', 10), 1);
      const currentPage = Math.max(parseInt(content?.dataset.collectionCurrentPage || '1', 10), 1);
      const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });
      const colorLabels = {
        beige_marble: 'Beige Marble',
        black_marble: 'Black Marble',
        green_marble: 'Green Marble',
        white_marble: 'White Marble',
        traverten: 'Travertine',
        travertine: 'Travertine'
      };
      const legLabels = {
        black: 'Black Leg',
        black_leg: 'Black Leg',
        white: 'White Leg',
        white_leg: 'White Leg',
        wood: 'Wooden Leg',
        wood_leg: 'Wooden Leg',
        wooden_leg: 'Wooden Leg'
      };
      const allCards = [];
      const seenCards = new Set();
      const paramFor = (key) => `theme_filter_${key}`;
      const inputs = () => Array.from(filters.querySelectorAll('[data-theme-filter-input]'));
      const splitValues = (value) => String(value || '').split('||').map((item) => item.trim()).filter(Boolean);
      const unique = (values) => Array.from(new Set(values.map((value) => String(value || '').trim()).filter(Boolean)));
      const humanize = (value, key = '') => {
        const cleanValue = String(value || '').trim();
        const normalizedValue = cleanValue.toLowerCase().replace(/[\s-]+/g, '_');
        if (key === 'leg' && legLabels[normalizedValue]) return legLabels[normalizedValue];
        const mapped = colorLabels[cleanValue.toLowerCase()];
        if (mapped) return mapped;
        if (/^\d+([.,]\d+)?$/.test(cleanValue)) return cleanValue;
        return cleanValue
          .replace(/[_-]+/g, ' ')
          .replace(/\b\w/g, (letter) => letter.toUpperCase());
      };

      const modelValue = (card) => {
        if (card.dataset.themeModel) return card.dataset.themeModel;
        const link = card.querySelector('.preferred-product-card__title[href], a[href*="/products/"]');
        const href = link?.getAttribute('href') || '';
        const handle = href.split('/products/')[1]?.split(/[?#/]/)[0];
        return handle || (link?.textContent || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
      };

      const modelLabel = (card) => {
        if (card.dataset.themeModelLabel) return card.dataset.themeModelLabel;
        return card.querySelector('.preferred-product-card__title')?.textContent?.trim() || modelValue(card);
      };

      const mediaMap = (card) => {
        if (card.__themeMediaMap !== undefined) return card.__themeMediaMap;
        const raw = card.querySelector('[data-media-map]')?.getAttribute('data-media-map');
        if (!raw) {
          card.__themeMediaMap = null;
          return null;
        }
        try {
          const parsed = JSON.parse(raw);
          card.__themeMediaMap = typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
        } catch (error) {
          card.__themeMediaMap = null;
        }
        return card.__themeMediaMap;
      };

      const valuesFromMediaMap = (card, key) => {
        const map = mediaMap(card);
        const sets = map?.sets || {};
        return unique(Object.keys(sets).flatMap((setKey) => {
          return setKey.split('|').map((part) => {
            const [name, value] = part.split('=');
            if (!value) return '';
            if (key === 'color' && ['color', 'renk'].includes(name)) return humanize(value, 'color');
            if (key === 'size' && ['size', 'olcu', 'ölçü', 'boyut'].includes(name)) return humanize(value, 'size');
            if (key === 'leg' && ['leg', 'ayak'].includes(name)) return humanize(value, 'leg');
            return '';
          });
        }));
      };

      const valuesFromImageAlts = (card, key) => {
        const pattern = key === 'color' ? /(?:color|renk)=([^|\s]+)/i :
          key === 'size' ? /(?:size|olcu|ölçü|boyut)=([^|\s]+)/i :
          /(?:leg|ayak)=([^|\s]+)/i;
        return unique(Array.from(card.querySelectorAll('img[alt]')).map((image) => {
          const match = image.getAttribute('alt')?.match(pattern);
          return match ? humanize(match[1], key) : '';
        }));
      };

      const fallbackLegs = () => splitValues(filters.dataset.fallbackLegs).length ?
        splitValues(filters.dataset.fallbackLegs) :
        ['White Leg', 'Black Leg', 'Wooden Leg'];

      const cardValues = (card, key) => {
        if (key === 'model') return [modelValue(card)].filter(Boolean);
        if (key === 'color') {
          return unique([
            ...splitValues(card.dataset.themeColors),
            ...Array.from(card.querySelectorAll('[data-color-value], .preferred-product-card__swatch[title]')).map((swatch) => swatch.dataset.colorValue || swatch.getAttribute('title')),
            ...valuesFromMediaMap(card, 'color'),
            ...valuesFromImageAlts(card, 'color')
          ]);
        }
        if (key === 'size') {
          const declaredSizes = splitValues(card.dataset.themeSizes);
          return declaredSizes.length ? unique(declaredSizes) : unique([
            ...valuesFromMediaMap(card, 'size'),
            ...valuesFromImageAlts(card, 'size')
          ]);
        }
        if (key === 'leg') {
          const declaredLegs = splitValues(card.dataset.themeLegs);
          const legs = declaredLegs.length ? unique(declaredLegs) : unique([
            ...valuesFromMediaMap(card, 'leg'),
            ...valuesFromImageAlts(card, 'leg')
          ]);
          return legs.length ? legs : fallbackLegs();
        }
        return [];
      };

      const collectCards = (cards) => {
        Array.from(cards).forEach((card) => {
          const key = modelValue(card) || card.textContent.trim().slice(0, 80);
          if (!key || seenCards.has(key)) return;
          seenCards.add(key);
          allCards.push(card.cloneNode(true));
        });
      };

      const stateFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return Object.fromEntries(keys.map((key) => [key, params.getAll(paramFor(key))]));
      };

      const selected = () => {
        const state = Object.fromEntries(keys.map((key) => [key, []]));
        inputs().forEach((input) => {
          if (input.checked && state[input.dataset.filterKey]) state[input.dataset.filterKey].push(input.value);
        });
        return state;
      };

      const activePairs = (state) => keys.flatMap((key) => state[key].map((value) => ({ key, value })));

      const syncFromUrl = () => {
        const state = stateFromUrl();
        inputs().forEach((input) => {
          input.checked = state[input.dataset.filterKey]?.includes(input.value);
        });
      };

      const updateUrl = () => {
        const url = new URL(window.location.href);
        keys.forEach((key) => url.searchParams.delete(paramFor(key)));
        inputs().forEach((input) => {
          if (input.checked) url.searchParams.append(paramFor(input.dataset.filterKey), input.value);
        });
        url.searchParams.delete('page');
        window.history.replaceState({}, '', url.toString());
      };

      const buildOptions = (state = selected()) => {
        keys.forEach((key) => {
          const body = optionBodies[key];
          const group = body.closest('details');
          const optionMap = new Map();

          allCards.forEach((card) => {
            if (key === 'model') {
              const value = modelValue(card);
              if (value) optionMap.set(value, modelLabel(card));
              return;
            }
            cardValues(card, key).forEach((value) => optionMap.set(value, value));
          });

          const options = Array.from(optionMap.entries()).sort((a, b) => collator.compare(a[1], b[1]));
          body.innerHTML = '';
          group.hidden = options.length === 0;

          options.forEach(([value, label], index) => {
            const optionId = `${filterUid}-${key}-${index}`;
            const wrapper = document.createElement('label');
            const input = document.createElement('input');
            const box = document.createElement('span');
            const text = document.createElement('span');

            wrapper.className = 'collection-theme-filters__option';
            wrapper.setAttribute('for', optionId);
            input.id = optionId;
            input.type = 'checkbox';
            input.value = value;
            input.checked = state[key]?.includes(value) || false;
            input.dataset.themeFilterInput = '';
            input.dataset.filterKey = key;
            box.className = 'collection-theme-filters__box';
            box.setAttribute('aria-hidden', 'true');
            text.className = 'collection-theme-filters__label';
            text.textContent = label;

            wrapper.append(input, box, text);
            body.appendChild(wrapper);
          });
        });
      };

      const includesAny = (source, wanted) => {
        if (!wanted.length) return true;
        return wanted.some((value) => source.includes(value));
      };

      const labelFor = (key, value) => {
        const input = inputs().find((item) => item.dataset.filterKey === key && item.value === value);
        return input?.closest('label')?.querySelector('.collection-theme-filters__label')?.textContent?.trim() || value;
      };

      const renderActive = (items) => {
        if (!activeEl) return;
        activeEl.innerHTML = '';
        activeEl.hidden = items.length === 0;
        items.forEach(({ key, value }) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'collection-theme-filters__chip';
          button.dataset.themeFilterRemoveKey = key;
          button.dataset.themeFilterRemoveValue = value;
          button.textContent = `${labelFor(key, value)} x`;
          activeEl.appendChild(button);
        });
      };

      const cardMatches = (card, state) => {
        return keys.every((key) => includesAny(cardValues(card, key), state[key]));
      };

      const COLOR_TOKENS = { 'beyaz mermer': ['white_marble'], 'beyaz': ['white_marble'], 'white marble': ['white_marble'], 'white': ['white_marble'], 'bej mermer': ['beige_marble'], 'bej': ['beige_marble', 'beige'], 'beige marble': ['beige_marble'], 'beige': ['beige_marble', 'beige'], 'siyah mermer': ['black_marble'], 'siyah': ['black_marble', 'black'], 'black marble': ['black_marble'], 'black': ['black_marble', 'black'], 'yesil mermer': ['green_marble'], 'yeşil mermer': ['green_marble'], 'green marble': ['green_marble'], 'yesil': ['green_marble', 'green'], 'yeşil': ['green_marble', 'green'], 'green': ['green_marble', 'green'], 'traverten': ['traverten'], 'travertine': ['traverten'], 'bordo mermer': ['bordo_mermer', 'bordeaux_marble'], 'bordeaux mermer': ['bordo_mermer', 'bordeaux_marble'], 'bordo marble': ['bordo_mermer', 'bordeaux_marble'], 'bordeaux marble': ['bordo_mermer', 'bordeaux_marble'], 'bordo': ['bordo_mermer', 'bordeaux_marble', 'bordo', 'bordeaux'], 'bordeaux': ['bordo_mermer', 'bordeaux_marble', 'bordo', 'bordeaux'] };
      const LEG_TOKENS = { 'beyaz ayak': 'white', 'white leg': 'white', 'siyah ayak': 'black', 'black leg': 'black', 'ahşap ayak': 'wood', 'ahsap ayak': 'wood', 'wooden leg': 'wood', 'wood leg': 'wood' };
      const normalizeText = (s) => (s == null ? '' : String(s)).trim().toLowerCase();
      const tokensForColor = (val) => { const k = normalizeText(val); if (!k) return []; if (COLOR_TOKENS[k]) return COLOR_TOKENS[k]; return [k.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')]; };
      const tokenForSize = (val) => { const raw = val == null ? '' : String(val); const imperial = raw.match(/(\d+(?:\.\d+)?)\s*(?:in\b|\")/i); if (imperial) return String(Math.round(Number(imperial[1]) * 2.54)); const metric = raw.match(/\d+(?:\.\d+)?/); return metric ? String(Math.round(Number(metric[0]))) : null; };
      const tokenForLeg = (val) => LEG_TOKENS[normalizeText(val)] || null;
      const buildKey = (renk, olcu, leg) => { const parts = ['color=' + renk]; if (olcu) parts.push('size=' + olcu); if (leg) parts.push('leg=' + leg); return parts.join('|'); };
      const legacyBuildKey = (renk, olcu, leg) => { const parts = ['renk=' + renk]; if (olcu) parts.push('olcu=' + olcu); if (leg) parts.push('leg=' + leg); return parts.join('|'); };
      const readSet = (sets, renk, olcu, leg) => sets[buildKey(renk, olcu, leg)] || sets[legacyBuildKey(renk, olcu, leg)] || null;
      const findSet = (mediaMap, renk, olcu, leg) => {
        if (!mediaMap || !renk) return null;
        const sets = mediaMap.sets || {};
        if (olcu && leg && readSet(sets, renk, olcu, leg)) return readSet(sets, renk, olcu, leg);
        if (olcu && readSet(sets, renk, olcu)) return readSet(sets, renk, olcu);
        if (olcu) {
          const target = parseInt(olcu, 10);
          if (!isNaN(target)) {
            const prefixes = ['color=' + renk + '|size=', 'renk=' + renk + '|olcu='];
            const candidates = Object.keys(sets)
              .filter((k) => prefixes.some((prefix) => k.indexOf(prefix) === 0) && k.indexOf('|leg=') === -1)
              .map((k) => { const m = k.match(/(?:size|olcu)=(\d+)/); return m ? { key: k, size: parseInt(m[1], 10) } : null; })
              .filter(Boolean)
              .sort((a, b) => Math.abs(a.size - target) - Math.abs(b.size - target));
            if (candidates.length) return sets[candidates[0].key];
          }
        }
        if (sets['color=' + renk]) return sets['color=' + renk];
        if (sets['renk=' + renk]) return sets['renk=' + renk];
        return null;
      };

      const pickPrimary = (set) => {
        if (!set || !set.length) return null;
        const front = set.find(i => i.alt && (i.alt.toLowerCase().includes('perspektif') || i.alt.toLowerCase().includes('background')));
        if (front) return front;
        const realFront = set.find(i => i.alt && i.alt.toLowerCase().includes('front'));
        return realFront || set[0];
      };
      
      const pickHover = (set) => {
        if (!set || !set.length) return null;
        return set.find(i => i.alt && i.alt.toLowerCase().includes('mekan_1')) || null;
      };

      const _mediaMapCache = new Map();
      const getMediaMap = (card) => {
        const handle = card.dataset?.themeModel;
        if (handle && _mediaMapCache.has(handle)) return _mediaMapCache.get(handle);
        let mm = null;
        const el = card.querySelector('[data-media-map]');
        if (el) {
          try {
            mm = JSON.parse(el.dataset.mediaMap);
            if (typeof mm === 'string') mm = JSON.parse(mm);
          } catch (e) { mm = null; }
        }
        if (handle) _mediaMapCache.set(handle, mm);
        return mm;
      };

      const getVariantMap = (card) => {
        const raw = card.dataset?.themeVariants;
        if (!raw) return null;
        try { return JSON.parse(raw); } catch (e) { return null; }
      };

      const applyVariantToCard = (source, clone, state) => {
        const variantMap = getVariantMap(source);
        if (!variantMap) return;
        const mediaMap = getMediaMap(source);

        const activeColor = state.color && state.color.length ? state.color.find(c => (source.dataset.themeColors || '').includes(c + '||')) : null;
        const activeSize = state.size && state.size.length ? state.size.find(s => (source.dataset.themeSizes || '').includes(s + '||')) : null;
        const activeLeg = state.leg && state.leg.length ? state.leg.find(l => (source.dataset.themeLegs || '').includes(l + '||')) : null;

        if (!activeColor && !activeSize && !activeLeg) return;

        let defaultKey = source.dataset.themeVariantDefault || '';
        let defaultParts = defaultKey.split('|');
        let colorToken = activeColor ? (tokensForColor(activeColor)[0] || '') : (defaultParts[0] || '');
        let sizeToken = activeSize ? (tokenForSize(activeSize) || '') : (defaultParts[1] || '');
        let legToken = activeLeg ? (tokenForLeg(activeLeg) || '') : (defaultParts[2] || '');

        /* Variant key ladder: try most specific → least specific */
        let vKey = null;
        const tries = [
          `${colorToken}|${sizeToken}|${legToken}`,
          `${colorToken}|${sizeToken}|`,
          `${colorToken}||${legToken}`,
          `${colorToken}||`,
        ];
        for (const k of tries) {
          if (variantMap[k]) { vKey = k; break; }
        }
        if (!vKey) return;

        const variantData = variantMap[vKey];
        const [vId, vPrice, vCompare, vAvailable] = variantData;

        /* --- Image swap --- */
        let targetSet = null;
        if (mediaMap && colorToken) {
          targetSet = findSet(mediaMap, colorToken, sizeToken, legToken);
        }
        
        if (targetSet && targetSet.length) {
          const primary = pickPrimary(targetSet);
          const hover = pickHover(targetSet);
          
          /* Main image: try multiple selectors */
          const mainImg = clone.querySelector('.product-primary-image__main')
                       || clone.querySelector('.preferred-product-card__media img')
                       || clone.querySelector('img');
          if (mainImg && primary && primary.url) {
            mainImg.src = primary.url;
            mainImg.alt = primary.alt || mainImg.alt;
            mainImg.removeAttribute('srcset');
            mainImg.setAttribute('data-original-src', primary.url);
            mainImg.removeAttribute('data-original-srcset');
          }
          
          /* Hover image */
          const hoverImg = clone.querySelector('.product-primary-image__hover');
          if (hoverImg) {
            if (hover && hover.url) {
              hoverImg.src = hover.url;
              hoverImg.alt = hover.alt || hoverImg.alt;
              hoverImg.removeAttribute('srcset');
            } else {
              hoverImg.remove();
            }
          }
        }

        /* --- Price --- */
        const priceEl = clone.querySelector('.preferred-product-card__price');
        if (priceEl && vPrice) priceEl.textContent = vPrice;
        
        let compareEl = clone.querySelector('.preferred-product-card__compare');
        if (vCompare) {
          if (!compareEl && priceEl && priceEl.parentNode) {
            compareEl = document.createElement('s');
            compareEl.className = 'preferred-product-card__compare';
            priceEl.parentNode.insertBefore(compareEl, priceEl);
          }
          if (compareEl) compareEl.textContent = vCompare;
        } else if (compareEl) {
          compareEl.remove();
        }

        /* --- Links with ?variant= --- */
        clone.querySelectorAll('a[href]').forEach(link => {
          const href = link.getAttribute('href') || '';
          if (href.includes('/products/')) {
            try {
              const url = new URL(href, window.location.origin);
              url.searchParams.set('variant', vId);
              link.setAttribute('href', url.pathname + url.search);
            } catch (e) {}
          }
        });

        /* --- Cart input --- */
        const cartInput = clone.querySelector('input[name="id"]');
        if (cartInput) cartInput.value = vId;

        /* --- Button state --- */
        const btn = clone.querySelector('.preferred-product-card__button, button[type="submit"]');
        if (btn) {
          if (!vAvailable) {
            btn.disabled = true;
            btn.textContent = 'Sold Out';
          } else {
            btn.disabled = false;
            if (btn.textContent.trim().toLowerCase().includes('sold')) btn.textContent = 'Add to Cart';
          }
        }

        /* --- Swatch selection --- */
        if (activeColor) {
          clone.querySelectorAll('.preferred-product-card__swatch').forEach(s => {
            s.classList.remove('is-selected');
            s.removeAttribute('data-selected');
            const sv = (s.dataset.colorValue || s.getAttribute('title') || '').trim();
            if (sv === activeColor) {
              s.classList.add('is-selected');
              s.setAttribute('data-selected', 'true');
            }
          });
        }
      };

      const render = () => {
        const state = selected();
        const pairs = activePairs(state);
        renderActive(pairs);
        if (clearBtn) clearBtn.hidden = pairs.length === 0;

        if (!pairs.length) {
          grid.innerHTML = originalHtml;
          if (countEl) countEl.textContent = originalCount;
          if (pagination) pagination.hidden = false;
          if (emptyEl) emptyEl.hidden = true;
          if (window.__stonivaPruneSwatches) window.__stonivaPruneSwatches(grid);
          return;
        }

        const matches = allCards.filter((card) => cardMatches(card, state));
        grid.replaceChildren(...matches.map((source) => {
          const clone = source.cloneNode(true);
          applyVariantToCard(source, clone, state);
          return clone;
        }));
        if (window.__stonivaPruneSwatches) window.__stonivaPruneSwatches(grid);

        if (countEl) countEl.textContent = `${matches.length} products · ${allCards.length} total`;
        if (pagination) pagination.hidden = true;
        if (emptyEl) emptyEl.hidden = matches.length !== 0;
      };

      const loadRemainingPages = async () => {
        if (totalPages <= 1) return;
        await Promise.all(Array.from({ length: totalPages }, async (_, index) => {
          const pageNumber = index + 1;
          if (pageNumber === currentPage) return;
          const url = new URL(window.location.href);
          url.searchParams.set('page', pageNumber);
          try {
            const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            collectCards(doc.querySelectorAll('.collection-products .collection-product-card, .collection-products [data-theme-filter-card]'));
          } catch (error) {
            console.warn('Collection filters could not load page', pageNumber, error);
          }
        }));
      };

      collectCards(grid.querySelectorAll('.collection-product-card, [data-theme-filter-card]'));
      buildOptions(stateFromUrl());
      syncFromUrl();
      render();

      loadRemainingPages().then(() => {
        buildOptions(selected());
        syncFromUrl();
        render();
      });

      filters.addEventListener('change', (event) => {
        if (!event.target.matches('[data-theme-filter-input]')) return;
        updateUrl();
        render();
      });

      const drawer = page.querySelector('[data-filter-drawer]');
      const backdrop = page.querySelector('.collection-page__filters-backdrop');
      const toggleDrawer = page.querySelector('[data-filter-toggle]');

      if (toggleDrawer && drawer && backdrop) {
        const openDrawer = () => {
          drawer.classList.add('is-open');
          backdrop.classList.add('is-open');
          toggleDrawer.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
        };

        const closeDrawer = () => {
          drawer.classList.remove('is-open');
          backdrop.classList.remove('is-open');
          toggleDrawer.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        };

        toggleDrawer.addEventListener('click', openDrawer);

        page.querySelectorAll('[data-filter-close]').forEach(btn => {
          btn.addEventListener('click', closeDrawer);
        });
      }

      activeEl?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-theme-filter-remove-key]');
        if (!button) return;
        const input = inputs().find((item) =>
          item.dataset.filterKey === button.dataset.themeFilterRemoveKey &&
          item.value === button.dataset.themeFilterRemoveValue
        );
        if (input) input.checked = false;
        updateUrl();
        render();
      });

      clearBtn?.addEventListener('click', () => {
        inputs().forEach((input) => {
          input.checked = false;
        });
        updateUrl();
        render();
      });

      window.addEventListener('popstate', () => {
        buildOptions(stateFromUrl());
        syncFromUrl();
        render();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
